"use client"

import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ChevronUp, ChevronDown } from "lucide-react";
import Image from "next/image";

type Testimonial = {
    id: number;
    review: string;
    name: string;
    location: string;
    img: string;
};

export const TestimonialsCarousel = ({ testimonials }: { testimonials: Testimonial[] }) => {

    const swiperRef = useRef<any>(null);

    return (
        <div className="flex items-center flex-col md:flex-row gap-2 md:gap-8">
            <Swiper
                breakpoints={{
                    0: {
                        direction: "horizontal",
                        slidesPerView: 1,
                    },
                    768: {  // md breakpoint in Tailwind
                        direction: "vertical",
                        slidesPerView: 1,
                    }
                }}
                slidesPerView={1}
                spaceBetween={20}
                modules={[Navigation]}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                className="w-[250px] md:w-[400px] md:h-[300px]"
            >
                {testimonials.map((test) => (
                    <SwiperSlide key={test.id}>
                        <div className="md:shadow-md py-12 md:px-8 rounded-2xl flex flex-wrap md:flex-nowrap flex-col gap-8">
                            <p className="w-full text-[#5E6282] text-[17px]">{test.review}</p>
                            <div className="flex items-center gap-4">
                                <Image src={test.img} alt={test.review} width={48} height={48} className="w-12 h-12 rounded-full" />
                                <div>
                                    <h3 className="font-bold">{test.name}</h3>
                                    <span className="font-thin">{test.location}</span>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="flex md:flex-col gap-4">
                <button
                    className="p-2 rounded-full text-primary hover:bg-gray-400 transition rotate-90 md:rotate-0"
                    onClick={() => swiperRef.current?.slidePrev()}
                >
                    <ChevronUp size={24} />
                </button>
                <button
                    className="p-2 rounded-full text-primary hover:bg-gray-400 transition rotate-90 md:rotate-0"
                    onClick={() => swiperRef.current?.slideNext()}
                >
                    <ChevronDown size={24} />
                </button>
            </div>

        </div>
    );
};
